import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "./site/ThemeContext";
import { VersionWatcher } from "./site/VersionWatcher";
import { Navbar } from "./site/Navbar";
import { Hero } from "./site/Hero";
import { Marquee } from "./site/Marquee";
import { Capabilities } from "./site/Capabilities";
import { Portfolio } from "./site/Portfolio";
import { Manifesto } from "./site/Manifesto";
import { Founder } from "./site/Founder";
import { Contact } from "./site/Contact";
import { Footer } from "./site/Footer";

function Site() {
  const { theme } = useTheme();

  useEffect(() => {
    document.body.style.background = theme === "dark" ? "#050713" : "#eef1fb";
  }, [theme]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className={`theme-${theme} bg-app relative min-h-screen transition-colors duration-500`}>
      <VersionWatcher />
      <Toaster
        position="bottom-right"
        theme={theme}
        toastOptions={{
          style: {
            background: "var(--surface-solid)",
            border: "1px solid var(--border-hover)",
            color: "var(--text)",
            backdropFilter: "blur(12px)",
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Capabilities />
        <Portfolio />
        <Manifesto />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function Landing() {
  return (
    <ThemeProvider>
      <Site />
    </ThemeProvider>
  );
}
